const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Wraps every case-insensitive occurrence of `query` in `text` with `<strong>`. */
export const highlightMatch = (text: string, query: string) => {
  if (!query) {
    return text;
  }
  const regex = new RegExp(`(${escapeRegExp(query)})`, 'gi');
  return text.split(regex).map((part, index) =>
    regex.test(part) ? (
      <strong key={index} style={{ fontWeight: 'bold' }}>
        {part}
      </strong>
    ) : (
      part
    ),
  );
};
